"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const session_1 = require("../../../../session");
const dates_and_calendars_1 = require("../dates-and-calendars");
function Definition(params) {
    return {
        getData(session = (0, session_1.getDefault)()) {
            const datesAndCalendarsProvider = new dates_and_calendars_1.DatesAndCalendarsProvider(session);
            return datesAndCalendarsProvider.getDateSchedule([params]);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9kYXRlcy1hbmQtY2FsZW5kYXJzL2RhdGUtc2NoZWR1bGUvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpREFBaUQ7QUFDakQsZ0VBQW1FO0FBRW5FLFNBQWdCLFVBQVUsQ0FDdEIsTUFBaUQ7SUFFakQsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLG9CQUFVLEdBQUU7WUFDbkMsTUFBTSx5QkFBeUIsR0FBRyxJQUFJLCtDQUF5QixDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBRXpFLE9BQU8seUJBQXlCLENBQUMsZUFBZSxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUMvRCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFWRCxnQ0FVQyJ9